import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';

export const recordPageView = () => {
	// Check if Google Analytics's been initialized
	ReactGA.ga(() => {
		ReactGA.set({ page: window.location.pathname });
		ReactGA.send({
			hitType: 'pageview',
			page: window.location.pathname + window.location.search
		});
	});
	ReactPixel.pageView();
};
